import type { ParsedBigNumberValue } from 'src/types/bigNumbers2'

const NUMBER_TOKEN_REGEX = /-?\d[\d.,]*/

const normalizeNumberToken = (token: string) => {
  const isNegative = token.trim().startsWith('-')
  const digitsOnly = token.replace(/\D/g, '')

  if (!digitsOnly) {
    return 0
  }

  const value = Number(digitsOnly)

  return isNegative ? -value : value
}

const shouldUseGrouping = (numberToken: string, value: number) => {
  return numberToken.includes('.') || numberToken.includes(',') || value >= 1000
}

export const formatBigNumberValue = (value: number, numberToken: string) => {
  if (!shouldUseGrouping(numberToken, value)) {
    return `${value}`
  }

  return new Intl.NumberFormat('pt-BR').format(value)
}

export const parseBigNumberValue = (rawValue: string): ParsedBigNumberValue => {
  const safeValue = rawValue?.trim() ?? ''

  if (!safeValue) {
    return {
      prefix: '',
      suffix: '',
      raw: '',
      hasNumericValue: false,
      numericValue: 0,
      numberToken: '',
    }
  }

  const tokenMatch = safeValue.match(NUMBER_TOKEN_REGEX)

  if (!tokenMatch || tokenMatch.index === undefined) {
    return {
      prefix: '',
      suffix: '',
      raw: safeValue,
      hasNumericValue: false,
      numericValue: 0,
      numberToken: '',
    }
  }

  const [numberToken] = tokenMatch
  const tokenStart = tokenMatch.index
  const tokenEnd = tokenStart + numberToken.length

  return {
    prefix: safeValue.slice(0, tokenStart),
    suffix: safeValue.slice(tokenEnd),
    raw: safeValue,
    hasNumericValue: true,
    numericValue: normalizeNumberToken(numberToken),
    numberToken,
  }
}
